export default __webpack_public_path__ + "static/media/mon_permanent.2ae676f2.jpg";